import * as React from 'react';
import {
  Button,
  Checkbox,
  Chips,
  InputAdornment,
  MaskedInput,
  Select,
  UIHeading1,
  UIHeading4,
  UIText3,
} from '@cian/ui-kit';
import { IFormProps } from '../../containers/Referral/Form/hooks/useFormProps';

import * as styles from './styles.css';
import { CONSENT_PERSONAL_DATA, MARKETING_AGREEMENT, PRIVACY_POLICY } from '../../containers/Referral/Form/constants';

const CODE_MASK = '(000) 000 00-00';

export const FormBanner: React.FC<IFormProps> = ({
  dealTypeValue,
  dealTypeOptions,
  dealTypeChange,
  phoneValue,
  onPhoneChange,
  regionValue,
  regionOptions,
  onRegionChange,
  onSubmit,
  legalAgreementAccepted,
  onLegalAgreementChange,
  isDesktop,
  errors,
}) => {
  return (
    <section data-testid="FormBanner" className={styles['container']}>
      <UIHeading1 as="h2" color="text-inverted-default">
        Не тратьте время — доверьтесь&nbsp;профи
      </UIHeading1>

      <div className={styles['form-item']}>
        <UIHeading4 as="p" color="text-inverted-default">
          С чем нужна помощь?
        </UIHeading4>
        <Chips
          value={dealTypeValue}
          options={dealTypeOptions}
          selectType="single"
          onChipClick={dealTypeChange}
          size="M"
          invalid={!!errors?.dealTypeError}
        />
        {!!errors?.dealTypeError && <UIText3 color="text-inverted-default">{errors.dealTypeError}</UIText3>}
      </div>

      <div className={styles['form']}>
        <div className={styles['form-item']}>
          {!isDesktop && (
            <UIHeading4 as="p" color="text-inverted-default">
              На какой номер перезвонить?
            </UIHeading4>
          )}
          <MaskedInput
            title={!isDesktop ? 'На какой номер перезвонить?' : undefined}
            leftAdornment={<InputAdornment>+7</InputAdornment>}
            value={phoneValue}
            onChange={onPhoneChange}
            lazy
            size="M"
            mask={CODE_MASK}
            placeholder="Номер телефона"
            invalid={!!errors?.phoneError}
          />
          {!!errors?.phoneError && <UIText3 color="text-inverted-default">{errors.phoneError}</UIText3>}
        </div>

        <div></div>
        <div className={styles['form-item']}>
          {!isDesktop && (
            <UIHeading4 as="p" color="text-inverted-default">
              В каком регионе?
            </UIHeading4>
          )}
          <Select
            title={isDesktop ? 'В каком регионе?' : undefined}
            value={regionValue}
            options={regionOptions}
            onChange={onRegionChange}
            size="M"
            placeholder="Выберите регион"
            invalid={!!errors?.regionError}
          />
          {!!errors?.regionError && <UIText3 color="text-inverted-default">{errors.regionError}</UIText3>}
        </div>

        <div className={styles['form-item']}>
          <Button
            theme="fill_primary"
            size="M"
            onClick={() => onSubmit('referralLandingPageForm')}
            fullWidth={!isDesktop}
          >
            Перезвоните мне
          </Button>
        </div>
      </div>
      <div className={styles['link-item']}>
        <Checkbox
          checked={legalAgreementAccepted}
          onChange={onLegalAgreementChange}
          label={
            <UIText3 color="text-inverted-default">
              Соглашаюсь на{' '}
              <a href={MARKETING_AGREEMENT} className={styles['link']} target="_blank" rel="noopener noreferrer">
                рассылки и звонки
              </a>
            </UIText3>
          }
        />
      </div>

      <div className={styles['link-item']}>
        <UIText3 color="text-inverted-default">
          {`Нажимая «Перезвоните мне», я даю`}{' '}
          <a href={CONSENT_PERSONAL_DATA} target="_blank" className={styles['link']} rel="noreferrer">
            Согласие на обработку персональных данных
          </a>{' '}
          в соответствии с{' '}
          <a href={PRIVACY_POLICY} target="_blank" className={styles['link']} rel="noreferrer">
            Политикой конфиденциальности
          </a>
        </UIText3>
      </div>
    </section>
  );
};
